import React from 'react'

const Home = () => {
  return (
    <div className='h-screen grid place-content-center'>
       
    <div className='flex justify-center gap-4'>
        
            <h2 className="font-light lg:text-7xl text-4xl text-gray-400"> Swimmunity </h2>
            <h2 className="font-light lg:text-7xl  text-4xl text-blue-500"> .verify</h2>
   </div>
   </div>
  )
}

export default Home